import { ApiCrud } from 'adready-api/api/api-crud';
import http from 'adready-api/api/http';

const dealsApi = new ApiCrud(http.AXIOS, {
  getDeals: 'GET deals',
});

export default dealsApi;
